import type React from 'react';

import { useDecisionMakerProfilePageData } from '#src/app/pages/decisionMaker/profile/pageContext';

import { useResponsivenessScoreEnabled } from '../../layout/hooks/useResponsivenessScoreEnabled';

import { AvatarAndBadge } from './components/AvatarAndBadge';
import { Description } from './components/Description';
import { DmStats } from './components/DmStats';
import { NameAndTitle } from './components/NameAndTitle';
import { ResponsivenessScore } from './components/ResponsivenessScore';
import { useProfileCardViewTracker } from './hooks/useProfileCardTracker';

export const ProfileCard: React.FC<EmptyProps> = () => {
	useProfileCardViewTracker();

	const {
		data: {
			featureConfigs: { dmReputationLayer },
		},
	} = useDecisionMakerProfilePageData();

	// Only show DmStats if it's not a DMRL enabled page
	const showDmStats = !dmReputationLayer.enabled;

	const responsivenessScoreEnabled = useResponsivenessScoreEnabled();

	return (
		<>
			<div className="mb-8 mb-14 px-4 md:px-0">
				<div
					className="mb-6 flex flex-col items-center justify-between gap-6 lg:flex-row lg:items-start"
					data-qa="dm-header"
				>
					{/* eslint-disable-next-line @change-ds/ds-no-arbitrary-spacing-classname */}
					<div className="absolute top-[59px] h-[105px] w-full lg:hidden">
						<div className="relative h-full w-full">
							<div className="bg-background-raised h-full w-full"></div>
							<div className="bg-background-base absolute bottom-[-50px] h-[100px] w-full rounded-tl-[100%] rounded-tr-[100%]"></div>
						</div>
					</div>
					<div className="items-center gap-6 lg:flex">
						<AvatarAndBadge />
						<div className="mt-6">
							<NameAndTitle />
						</div>
					</div>
					{responsivenessScoreEnabled && <ResponsivenessScore />}
				</div>

				<Description />
			</div>
			{showDmStats && <DmStats />}
		</>
	);
};
